import { inject, Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { AssignMembersToJobsDialogResult } from '@core/tellent-assign-members-to-jobs-types';
import { DialogService, DialogWidth } from '@core/user-interface-legacy';

import { AssignMembersToJobsDialogComponent } from './assign-members-to-jobs-dialog.component';

@Injectable({
  providedIn: 'root',
})
export class AssignMembersToJobsService {
  private readonly dialogService = inject(DialogService);

  public openAssignMembersDialog(dialogData: any): Observable<AssignMembersToJobsDialogResult> {
    return this.dialogService.openDialog(AssignMembersToJobsDialogComponent, dialogData, {
      width: DialogWidth.Small,
      containerOptions: { fullscreenOnMobile: true },
    }).afterClosed;
  }
}
